
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy",
      function () {
        return require("private-next-pages/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy"])
      });
    }
  